import { AgnosticRouteObject } from '@sentry/react/types/types'

import { appConfig } from '@/app-config/appConfig'
import { RequestOverrides } from '@/clients/BaseApiClient'
import { getGGClient } from '@/clients/gg/GetGoingClient'
import { Routes } from '@/lib/routes'
import { DADestinationZ, DailyAllowanceRateZ } from '@/types/expenses/dailyAllowance'
import { SupportApiFile } from '@/types/expenses/supportApiFiles'

export async function getDestinations(posId: number, overrides?: RequestOverrides) {
	return getGGClient()
		.request('GET', `expense_policies/daily_allowances/pos/${posId}/destinations`, {
			responseSchema: DADestinationZ.array(),
			...overrides,
		})
		.then((r) => r.data)
}
getDestinations.queryKey = (posId?: number) => [`expense_policies/daily_allowances/pos/${posId}/destinations`]

export async function getRates(destinationId: number, overrides?: RequestOverrides) {
	return getGGClient()
		.request('GET', `expense_policies/daily_allowances/destination/${destinationId}/rates`, {
			responseSchema: DailyAllowanceRateZ.array(),
			...overrides,
		})
		.then((r) => r.data)
}

getRates.queryKey = (destinationId?: number) => [`expense_policies/daily_allowances/destination/${destinationId}/rates`]

export async function getSupportApiFiles(route: AgnosticRouteObject) {
	const filesPlaceholder = [{ label: 'Placeholder for downloading API Files', url: '' }].map((file) => ({
		...file,
		url: `${appConfig.WEB_ORIGIN}/static/docs/GetGoing%20T&C%20German%20-%20April12022.pdf`,
	}))

	// TODO replace with real API call when available
	const map: Partial<Record<Routes, SupportApiFile[]>> = {
		'/expenses/da/:id/review': filesPlaceholder,
		'/expenses/manage': filesPlaceholder,
		'/expenses/mileage/:id/review': filesPlaceholder,
		'/expenses/reports': filesPlaceholder,
		'/expenses/reports/:id/review': filesPlaceholder,
		'/expenses/se/:id/review': filesPlaceholder,
		'/policy/expense/:param0?/:param1?/:param2?': filesPlaceholder,
	}

	return new Promise<SupportApiFile[]>((resolve) => {
		setTimeout(() => resolve(map[route.path as Routes] ?? []), 0)
	})
}

getSupportApiFiles.queryKey = (url?: string) => [`support_api_files`, url]
